import axios from 'axios'
import { instance, instanceClippingPath } from './axiosConfig'
import { download, joinOwnerWithComma } from './utils'

export default {
  async getUserDetails(userId) {
    const url = `/external/legacy/users/${userId}/owners`

    return await instance.get(url)
  },

  async getUserOptions(userId) {
    const version = '1.28'
    const url = `/external/legacy/${version}/users/${userId}/options`

    try {
      return await instance.get(url)
    } catch (e) {
      return null
    }
  },

  async downloadAddendum(ownerId, productId, shootingId, registration, date) {
    const url = `/owners/${ownerId}/products/${productId}/shootings/${shootingId}/vhc/report`
    const fileName = `${date.replace(/\//gi, '-')}-${registration}.pdf`

    try {
      let res = await instance.get(url)
      const result = checkDownloadResult(res)

      if (!result.statusValid) return 'ERROR'
      if (!result.report) return 'NO_PDF'

      const pdfUrl = res.data.pdfUrl

      download(pdfUrl, fileName, true)

      function checkDownloadResult(res) {
        const statusValid = res && res.status === 200
        const report = res && res.data

        return {
          statusValid: statusValid,
          report: !!report
        }
      }

      return 'DONE'
    } catch (err) {
      return 'ERROR'
    }
  },

  formatResponse(data) {
    return {
      id: data.id,
      pdfUrl: data.pdfUrl,
      created: data.created,
      updated: data && data.updated
    }
  },

  checkDownloadInspectionResult(res) {
    const statusValid = res && res.status === 200
    const report = res && Object.keys(res.data).length > 0

    return {
      statusValid: statusValid,
      report: !!report
    }
  },

  async getInspectionReportUrlPdf(ownerId, productId, shootingId) {
    const url = `/owners/${ownerId}/products/${productId}/shootings/${shootingId}/damages/reports`

    try {
      let res = await instance.get(url)
      const result = this.checkDownloadInspectionResult(res)

      if (!result.statusValid) return 'ERROR'
      if (!result.report) return 'NO_PDF'

      return res.data[0].pdfUrl
    } catch (err) {
      return 'ERROR'
    }
  },

  async getTradeInOfferUrlPdf(ownerId, productId, shootingId) {
    const url = `/owners/${ownerId}/products/${productId}/shootings/${shootingId}/trade-in-offers/reports`

    try {
      let res = await instance.get(url)
      const result = this.checkDownloadInspectionResult(res)

      if (!result.statusValid) return 'ERROR'
      if (!result.report) return 'NO_PDF'

      return res.data.pdfUrl
    } catch (err) {
      return 'ERROR'
    }
  },

  async shootingOptions(ref) {
    const url = `/external/legacy/players/${ref}/options`

    try {
      return await instance.get(url)
    } catch (e) {
      return null
    }
  },

  async getGroupId(userId) {
    const url = `/external/legacy/users/${userId}/groupId`

    try {
      return await instance.get(url)
    } catch (e) {
      return null
    }
  },

  async getShootings(userId, offset = 0, limit = 12, startDate = null, endDate = null, registration, types) {
    registration = registration ? `&registration=${registration}` : ''
    startDate = startDate ? `&startDate=${startDate}` : ''
    endDate = endDate ? `&endDate=${endDate}` : ''

    const rawTypes = joinOwnerWithComma(types)

    const url = `/shootings?userId=${userId}&shootingTypes=${rawTypes}&limit=${limit}&offset=${offset}${startDate}${endDate}${registration}`

    try {
      return await instance.get(url)
    } catch (e) {
      return false
    }
  },

  // Get one shooting
  async getShooting(ownerId, productId, shootingId) {
    const url = `/owners/${ownerId}/products/${productId}/shootings/${shootingId}`

    try {
      return await instance.get(url)
    } catch (err) {
      return err
    }
  },

  async getShootingsInformations(ownerId, productId) {
    const url = `/owners/${ownerId}/products/${productId}`

    try {
      return await instance.get(url)
    } catch (err) {
      return err
    }
  },

  async addImagesToShooting(shootingId, images) {
    const url = `/shootings/${shootingId}/images`

    try {
      return await instance.post(url, images)
    } catch (err) {
      return err
    }
  },

  async advaloremVerificationCropping(shootingId, imageId, inputBody) {
    const url = `/api/V1/shootings/${shootingId}/images/${imageId}/verifications/cropped`

    try {
      return await instanceClippingPath.post(url, inputBody)
    } catch (err) {
      return err
    }
  },

  async advaloremVerification(shootingId, imageId, inputBody) {
    const url = `/api/V1/shootings/${shootingId}/images/${imageId}/verifications`

    try {
      return await instanceClippingPath.post(url, inputBody)
    } catch (err) {
      return err
    }
  },
  // Get video
  async getVideo(ownerId, productId, shootingId) {
    const url = `/owners/${ownerId}/products/${productId}/shootings/${shootingId}/videos`

    try {
      return await instance.get(url)
    } catch (err) {
      return err
    }
  },

  // Return ref for player
  async getPlayerInformations(idShooting) {
    const marketplace = 'STAMPYT'
    const url = `/shootings/${idShooting}/marketplaces/${marketplace}?urlshortened=true`

    try {
      return await instance.get(url)
    } catch (e) {
      return null
    }
  },

  // With one or multiple owners,
  // Retrieve the list of available vehicles
  // Api product
  async getProducts(ownersId) {
    let customResponse = {
        data: [],
        status: []
      },
      promises = []

    ownersId.forEach(function (ownerId) {
      const url = `/owners/${ownerId}/products?workflow=PHOTO&state=TODO`
      const config = {
        baseURL: process.env.VUE_APP_STAMPYT_API_HOST,
        headers: {
          ['x-api-key']: process.env.VUE_APP_STAMPYT_API_KEY,
          ['Access-Control-Allow-Origin']: '*'
        }
      }
      promises.push(axios.get(url, config))
    })

    await axios.all(promises).then(function (results) {
      results.forEach(function (response, index) {
        customResponse.status.push(response.status)
        response.data.forEach((el) => {
          customResponse.data.push({
            productId: el.id,
            registration: el.details.registration,
            ownerId: ownersId[index]
          })
        })
      })
    })

    return customResponse
  },

  // Get label to every owners
  async getLabelOwner(ownersId) {
    ownersId = joinOwnerWithComma(ownersId)
    const url = `/owners?ids=${ownersId}`

    try {
      return await instance.get(url)
    } catch (err) {
      return err
    }
    return res
  },

  // Create virtual Product vin
  async createVirtualProduct(ownerId, registration, uuid) {
    const url = '/products/virtuals'

    let body = {
      vin: `Virtual_${uuid}`,
      ownerId: ownerId,
      registration: registration,
      workflows: [
        {
          name: 'PHOTO'
        },
        {
          name: 'VIDEO'
        }
      ]
    }

    try {
      return await instance.post(url, body)
    } catch (err) {
      return err
    }
  },

  // Get all stamp for a user
  async getStamps(userId, format) {
    let url = `/users/${userId}/stamps`

    if (format) {
      url = `${url}?formats=${encodeURIComponent(format)}`
    }

    try {
      return await instance.get(url)
    } catch (err) {
      return err
    }
  },

  // Move images from s3 to SI
  async setImagesfromBucket(ownerId, productId, data) {
    const url = `/owners/${ownerId}/products/${productId}/shootings`

    try {
      return await instance.post(url, data)
    } catch (err) {
      return err
    }
  },

  // Create presigned url
  async generatePresignedUrl(productId, images) {
    const url = `/products/${productId}/shootings/generate_presigned_urls`
    const data = {
      images: images
    }

    try {
      return await instance.post(url, data)
    } catch (err) {
      return err
    }
  },

  async sendNotification(body, notificationType) {
    const url = `/notifications/${notificationType}`

    try {
      return await instance.post(url, body)
    } catch (e) {
      return null
    }
  },

  async generatePresignedUrlFromMedia(data) {
    const url = `/media/generate_presigned_urls`

    try {
      return await instance.post(url, data)
    } catch (error) {
      return false
    }
  },

  async putImageOnS3(presignedUrl, file) {
    let contentType = file.type
    // video/quicktime => .mov
    // video/mp4 => .mp4
    // video/webm => .webm (not supported)
    // video/avi => .avi (not supported, not read on player)
    // video/x-ms-wmv => .wmv (not supported, not read on player)

    // S3 presigned url only support iana content-type : https://www.iana.org/assignments/media-types/media-types.xhtml#video
    if (
      file.type === 'audio/ogg' ||
      file.type === 'video/x-ms-wmv' ||
      file.type === 'video/avi' ||
      file.type === 'video/webm'
    ) {
      contentType = 'application/octet-stream'
    }

    try {
      return await axios.put(presignedUrl, file, {
        headers: {
          'Content-Type': contentType
        }
      })
    } catch (error) {
      return error.response
    }
  },

  async sendStampShooting(ownerId, productId, shootingId, data) {
    const url = `/owners/${ownerId}/products/${productId}/shootings/${shootingId}/restamp`

    try {
      return await instance.post(url, data)
    } catch (err) {
      return err
    }
  },

  async replayDMS(shootingId) {
    const url = `/shootings/${shootingId}/replay_dms`

    try {
      return await instance.post(url)
    } catch (err) {
      return err
    }
  },

  async validWorkflow(ownerId, productId) {
    const workflowType = 'PHOTO'
    const url = `/products/${productId}/workflows/${workflowType}/done`

    return await instance.post(url, { ownerId })
  },

  async postNotificationVideo(body) {
    const url = `/videos/notification`

    try {
      return await instance.post(url, body)
    } catch (e) {
      return null
    }
  },

  async deleteShooting(ownerId, productId, shootingId) {
    const url = `/owners/${ownerId}/products/${productId}/shootings/${shootingId}?deleteSameDayRelatedShootings=true`

    try {
      return await instance.delete(url)
    } catch (e) {
      return null
    }
  },

  async deleteVideo(ownerId, productId, shootingId) {
    const url = `/owners/${ownerId}/products/${productId}/shootings/${shootingId}`

    try {
      return await instance.delete(url)
    } catch (e) {
      return null
    }
  },

  async sharedPlayerStatistics(userId, marketplaceProductRef, data) {
    const url = `/users/${userId}/statistics/players/${marketplaceProductRef}/shared`

    try {
      return await instance.post(url, data)
    } catch (e) {
      return null
    }
  },

  async sharedLiveVideoStatistics(userId, videoId, data) {
    const url = `/users/${userId}/statistics/videos/live/${videoId}/shared`

    try {
      return await instance.post(url, data)
    } catch (e) {
      return null
    }
  },

  async getStampConfiguration(stampId) {
    // Get the configuration of image
    const url = `/stamps/${stampId}`

    try {
      return await instance.get(url)
    } catch (err) {
      return err
    }
  },

  async applyLicensePlateCoverPositionOnImage(shootingId, imageId, data) {
    const url = `/shootings/${shootingId}/images/${imageId}/licence-plate-cover`

    try {
      const res = await instance.post(url, data)
      if (res.status < 200 || res.status >= 300) {
        const error = new Error(`${res.data.message}`)
        error.status = res.status
        error.isError = true
        throw error
      }

      return res.data
    } catch (err) {
      return err
    }
  },

  async stampImages(image) {
    const url = '/processes/stamp'

    try {
      const res = await instance.post(url, image)
      if (res.status < 200 || res.status >= 300) {
        const error = new Error(`${res.data.message}`)
        error.status = res.status
        error.isError = true
        throw error
      }
      return res
    } catch (err) {
      return err
    }
  },

  async reprocessShooting(shootingId, stampId) {
    const url = `/shootings/${shootingId}/stamps/${stampId}/reprocess`

    try {
      return await instance.post(url)
    } catch (err) {
      return err
    }
  },

  async processMedia(imageUrl, steps) {
    try {
      return await instance.post('/process', { url: imageUrl, steps })
    } catch (err) {
      return err
    }
  }
}
